import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6988256b921dc900142cd459/website_project/src/components/common/ScrollBackground.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6988256b921dc900142cd459/website_project/src/styles/index.css");
